import {registerJQueryComponent} from '@lib/JQueryRegistry'

export default class Counter {

    /**
     * Constructs a new {@link Counter}.
     * @param {HTMLElement} rootElement
     */
    constructor(rootElement) {
        this.$dom = {
            root: rootElement,
            plusButton: rootElement.find('.counter-button-plus.html'),
            minusButton: rootElement.find('.counter-button-minus.html'),
            counter: rootElement.find('.counter-current.html')
        }

        this.$state = {
            counter: 0
        }

        this.counterMin = 0
        this.counterMax = this.$dom.root.data('max')

        this.$dom.plusButton.click(this.onPlusButtonClicked)
        this.$dom.minusButton.click(this.onMinusButtonClicked)

        this.updateButtonStatus()
    }

    onPlusButtonClicked = () => {
        this.$state.counter++

        if (this.$state.counter > this.counterMax && this.counterMax > 0) {
            this.$state.counter = this.counterMax
        }

        this.$dom.counter.html(this.$state.counter)
        this.updateButtonStatus()
    }

    onMinusButtonClicked = () => {
        this.$state.counter--

        if (this.$state.counter < this.counterMin) {
            this.$state.counter = this.counterMin
        }

        this.$dom.counter.html(this.$state.counter)
        this.updateButtonStatus()
    }

    updateButtonStatus() {
        if (this.$state.counter === this.counterMin) {
            this.$dom.minusButton.addClass('inactive')
        } else {
            this.$dom.minusButton.removeClass('inactive')
        }

        if (this.counterMax > 0) {
            if (this.$state.counter === this.counterMax) {
                this.$dom.plusButton.addClass('inactive')
            } else {
                this.$dom.plusButton.removeClass('inactive')
            }
        } else {
            this.$dom.plusButton.removeClass('inactive')
        }
    }

    getCurrentCounterState() {
        return this.$state.counter
    }
}

registerJQueryComponent(Counter, '.counter-control.html')